<template>
  <div class="appdownload_container">
    <header>
      <div class="header appbar_tab1">
        <!-- 返回按钮 -->
        <div class="block_content">
          <a href="javascript:history.back()" class="subpage_backurl"><img alt="" src="/static/image/arrow_left.png" /></a>
        </div>
      </div>
    </header>
    <div class="appdownload_logo">
      <a href="#"><img alt="" src="/static/image/logo.png" /></a>
    </div>

    <!-- <div class="appdownload_supply_icon">
            <div class="block_content">
                <div><img alt="" src="/static/image/ronnie.png" width="48"></div>
                <div>品牌代言人<br>罗尼奥沙利文</div>
            </div>
            <div class="block_content">
                <div><img alt="" src="/static/image/LCFC.png" width="32"></div>
                <div>英超莱斯特城<br>官方合作伙伴<br/>2019/20</div>
            </div>
            <div class="block_content">
                <div><img alt="" src="/static/image/snooker.png" width="32"></div>
                <div>19 独家赞助<br>斯诺克系列赛<br/>2019/20</div>
            </div>
            <div class="block_content">
                <div><img alt="" src="/static/image/derby.png" width="32"></div>
                <div>英冠德比郡<br>官方合作伙伴<br/>2019/20</div>
            </div>
        </div> -->

    <div class="mb-4">
      <img alt="" src="/static/image/iphone_app.png" />
    </div>

    <div class="appdownload_desc">iOS 用户请使用 Safari 浏览器开启页面下载</div>

    <input type="hidden" name="allDownloadToken" />
    <a class="appdownload_btn mb-3 all-btn" @click="goApp">立即下载</a>

    <div class="appdownload_desc">请先删除旧版APP再重新安装</div>

    <div class="app_download_guide_img"><img src="/static/image/arrow_down.png" /></div>

    <div class="appdownload_desc mt-4">须在同一网络环境下下载安装和注册，勿切换网络， 若无法正常下载，请使用手机浏览器开启。</div>

    <div class="app_download_guide_container">
      <div class="app_download_guide">1. 点选【立即下载】</div>
      <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example0.png" /></div>

      <div class="app_download_guide">2. 点选【允许】</div>
      <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example1.png" /></div>

      <div class="app_download_guide">3. 点选【关闭】后进入设定</div>
      <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example2.png" /></div>

      <div class="app_download_guide">4. 点选描述文件安装</div>
      <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example3.png" /></div>

      <div class="app_download_guide">5. 点选【安装】</div>
      <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example4.png" /></div>

      <div class="app_download_guide">6. 【允许】网站配置描述文件</div>
      <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example5.png" /></div>

      <div class="app_download_guide">7. 点选【安装】即可成功安装、尽情游玩</div>
      <div class="app_download_guide_img"><img src="/static/image/ios_alert_box_example6.png" /></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {
    goApp() {
      let that = this;
      window.location.href = that.$store.state.appInfo.ios_download_url;
    },
    //下载文件
    downloadUrl(url) {
      let that = this;
      this.$parent.showLoading();

      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.display = 'none'; // 防止影响页面
      iframe.style.height = 0; // 防止影响页面
      document.body.appendChild(iframe); // 必写，iframe挂在到dom树上才会发请求
      // 定时删除节点
      setTimeout(() => {
        that.$parent.hideLoading();

        document.body.removeChild(iframe);
      }, 2000);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// css/app.css
@import '../../static/css/app.css';
.appdownload_btn {
  background: #fff;
  border: 2px solid var(--appdownload-btn-border-color);
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  color: #000 !important;
  display: block;
  padding: 6px 10px;
  width: 80%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/app.vue